import React, { FC } from 'react'
import { useToggle } from '@/hooks'
import classNames from 'classnames'
import { AccordionFaqProps } from '@/types'
import { AccordionFaqContext } from './accordion-faq-context'
import { AccordionFaqHeader } from './accordion-faq-header'
import { AccordionFaqContent } from './accordion-faq-content'

import styles from './accordion-faq.module.scss'

export const AccordionFaq: FC<AccordionFaqProps> = ({
  children,
  header,
  className,
  isOpened = false,
}: AccordionFaqProps) => {
  const { status: expanded, toggleStatus: toggleExpanded } = useToggle(isOpened)

  const value = {
    expanded,
    toggleExpanded,
  }

  return (
    <AccordionFaqContext.Provider value={value}>
      <div className={classNames(styles['root'], className)}>
        <AccordionFaqHeader>{header}</AccordionFaqHeader>
        <AccordionFaqContent>{children}</AccordionFaqContent>
      </div>
    </AccordionFaqContext.Provider>
  )
}
